import React from "react";
import {
  BrandCard,
  BrandImageLink,
  BrandBody,
  BrandFooter,
} from "./BrandHelpers";
import IBrand from "../../../../@types/IBrand";
import { slugify } from "transliteration";

const Brand: React.FC<IBrand> = (props) => {
  const logo = props.relationships?.field_logo;
  const path = props.path.alias;
  const description = props.description !== null ? props.description : null;
  const teaserImage = props.relationships?.field_teaser_image
    ? props.relationships.field_teaser_image.relationships.field_media_image
        .gatsbyImage
    : null;
  const alt = props.field_logo_alt_text || `${props.name} Logo`;
  return (
    <BrandCard id={slugify(props.name)}>
      <BrandImageLink
        path={path}
        name={props.name}
        image={teaserImage}
        id={"brand-image-link"}
      />
      <BrandBody logo={logo} content={description} alt={alt} />
      <BrandFooter brandPath={path} name={props.name} id={"explore-brand"} />
    </BrandCard>
  );
};

export default Brand;
